import request from '@/utils/request'
import { requestPath } from '@/utils/global.js'

export function downAPI(params) { //首页下载
    return request({
        url: `${requestPath.resource}/index/annex_/page`,
        method: 'get',
        params
    })
}
export function picAPI(params) { //首页图文
    return request({
        url: `${requestPath.resource}/index/article_/page`,
        method: 'get',
        params
    })
}
export function newBookAPI(params) { //首页新书
    return request({
        url: `${requestPath.resource}/index/ebook_/page`,
        method: 'get',
        params
    })
}
export function searchTopAPI(params) { //头部检索
    return request({
        url: `${requestPath.resource}/index/search`,
        method: 'get',
        params
    })
}
export function newsAPI(params) { //首页新闻
  return request({
      url: `${requestPath.sysuser}/news/list`,
      method: 'get',
      params
  })
}
export function lbtAPI(params) { //首页轮播图
  return request({
      url: `${requestPath.sysuser}/home-page/signvalue`,
      method: 'get',
      params
  })
}

export function newsListAPI(params) { //新闻搜索列表
  return request({
      url: `${requestPath.sysuser}/news/search`,
      method: 'get',
      params
  })
}

export function searchListAPI(params) { //列表
  return request({
      url: `${requestPath.resource}/index/search`,
      method: 'get',
      params
  })
}
export function diyTypeAPI(params) { //自定义分类
  return request({
      url: `${requestPath.resource}/diytype/tree`,
      method: 'get',
      params
  })
}
export function articleAPI(params) { //获取文章
  return request({
      url: `resource/pc_fg/article-library/get/oid`,
      method: 'get',
      params
  })
}

export function bookDetailAPI(params) { //获取图书详细信息
  return request({
      url: `resource/pc_fg/ebook/get/${params}`,
      method: 'get',
  })
}
export function newsDetailAPI(params) { //新闻详情
    return request({
        url: `${requestPath.sysuser}/news/${params}`,
        method: 'get'
    })
}
export function updateDownAPI(data) { //更新下载数
    return request({
        url: `${requestPath.resource}/annex-library/update/annex-library`,
        method: 'post',
        data
    })
}
export function getsignatureAPI(params) {
    return request({
        url: `${requestPath.third}/wechat-h5-login/signature`,
        method: 'get',
        params
    })
  }

export function isAddToCartAPI(params) { //验证用户资源是否添加购物车中
    return request({
        url: `${requestPath.order}/shopping/cart/get/isOrNot/addTo`,
        method: 'get',
        params
    })
}
export function addToCartAPI(data) { //购物车添加商品
    return request({
        url: `${requestPath.order}/shopping/cart/save`,
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/home/index.js